import styled from '@mui/material/styles/styled';

export const PageLoaderContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;
